import * as L from "leaflet";
import { IBoundLayer, IBoundLayerOptions } from "../../../map/BoundLayer";
import { getFlightMarkersList } from "../../../redux/modules/flightMarkers/flightMarkersReducer";
import {
  getFlightMarkersState,
  getModePilotUiState,
  getSiteState,
} from "../../../redux/rootReducer";
import { attachPopup, attachReactPopup } from "../../../map/popup";
import getFlightMarkerIcon from "../../getFlightMarkerIcon";
import { IFlightMarker } from "../../../apiFacades/bapi/flightMarkers";
import CoordinatesFlightMarkerPopupContent from "../CoordinatesFlightMarkerPopupContent";
import * as React from "react";
import { feetToMeters } from "../../../utils";
import {
  getSiteSrs,
  isSiteImperial,
} from "../../../redux/modules/site/reducer";
import { convertGlobalToWgs84Coords } from "../../../utils/coordinateConversion/convertGlobalToWgs84Coords";

export default class NailsLayer extends L.LayerGroup implements IBoundLayer {
  public options: IBoundLayerOptions;
  public map: L.Map;

  constructor(options: IBoundLayerOptions) {
    super();
    L.Util.setOptions(this, options);
  }

  public onAdd(map: L.Map) {
    L.LayerGroup.prototype.onAdd.call(this, map);
    this.map = map;
    return this;
  }

  public onRemove(map: L.Map) {
    L.LayerGroup.prototype.onRemove.call(this, map);
    this.map = null;
    return this;
  }

  public update() {
    this.clearLayers();
    const flightMarkersState = getFlightMarkersState(this.options.getState());
    const flightMarkersList = getFlightMarkersList(flightMarkersState);
    this.drawNails(flightMarkersList);
  }

  private drawNails(nails: IFlightMarker[]) {
    const { showFlightMarkerLabelsIsOn } = getModePilotUiState(
      this.options.getState(),
    );

    nails.forEach((flightMarker) => {
      if (flightMarker.tsArchived) {
        return;
      }

      const { operatorCoords, name } = flightMarker;
      const srs = getSiteSrs(getSiteState(this.options.getState()));
      const { x, y, z } = convertGlobalToWgs84Coords(operatorCoords, srs);
      const markerCoords: L.LatLng = L.latLng(y, x);
      const markerIcon = L.icon({
        iconUrl: getFlightMarkerIcon(flightMarker),
        iconSize: [24, 24],
      });
      const marker = L.marker(markerCoords, { icon: markerIcon });
      const shadowMarker = L.marker(markerCoords, { icon: markerIcon });

      const siteState = getSiteState(this.options.getState());
      const isImperial = isSiteImperial(siteState);

      attachReactPopup(marker, (updatePopupLayout, closePopup) => (
        <CoordinatesFlightMarkerPopupContent
          coordinates={{
            lat: y,
            lng: x,
            alt: isImperial ? feetToMeters(z) : z,
          }}
          name={name}
          updatePopupLayout={updatePopupLayout}
          closePopup={closePopup}
        />
      ));

      attachPopup(shadowMarker, name, null, showFlightMarkerLabelsIsOn);

      this.addLayer(shadowMarker);
      this.addLayer(marker);

      if (showFlightMarkerLabelsIsOn) {
        setTimeout(() => shadowMarker.openPopup(), 0);
      }
    });
  }
}
